<div class="headerMain">
    <img [src]="config.Server + 'assets/layout/images/companies/'+ selectedCompany?.bannerImage" />
    <p>{{selectedCompany?.name}}</p>
</div>